import { useTimesheetUIStore, DAY_TYPE_TABS } from '@/modules/drivers/stores/timesheetStore'
import type { DayTypeFormType } from '@/modules/drivers/stores/timesheetStore'

export type { DayTypeFormType }
export type TimesheetContextType = ReturnType<typeof useTimesheetUIStore.getState>

export const useTimesheet = useTimesheetUIStore

// Kept for callers that render <TimesheetProvider> — it's now a no-op wrapper.
const TimesheetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) =>
  children as React.ReactElement

export default TimesheetProvider
export { DAY_TYPE_TABS as allTabs }
